module.exports = __webpack_public_path__ + "img/ch.89992509.svg";